import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import TableDefinitions from '../../TableDefinitions';
import MrdMonitoringReportsAllMRDsContainer
  from '../../../application/mrd-monitoring/all-mrds/containers/MrdMonitoringReportsAllMRDsContainer';
import { tableLoadData } from '../actions/ListTableActions';
import MrdMonitoringReportsAllIssuesContainer
  from '../../../application/mrd-monitoring/all-issues/containers/MrdMonitoringReportsAllIssuesContainer';
import MrdMonitoringReportsReportedByUserContainer
  from '../../../application/mrd-monitoring/reported-by-user/containers/MrdMonitoringReportsReportedByUserContainer';
import MrdMonitoringReportsXmlDelayedContainer
  from '../../../application/mrd-monitoring/xml-delayed/containers/MrdMonitoringReportsXmlDelayedContainer';
import MrdMonitoringReportsNoSyncContainer
  from '../../../application/mrd-monitoring/no-sync/containers/MrdMonitoringReportsNoSyncContainer';
import DenestImpcMappingContainer
  from '../../../application/mrd-administration/impc-mapping/containers/DenestImpcMappingContainer';
import DeviceInformationContainer
  from '../../../application/mrd-administration/device-information/containers/DeviceInformationContainer';
import FlightInformationContainer
  from '../../../application/mrd-administration/flight-information/containers/FlightInformationContainer';
import HandlersContainer from '../../../application/mrd-administration/handlers/containers/HandlersContainer';
import DeviceSettingsContainer
  from '../../../application/mrd-administration/device-settings/containers/DeviceSettingsContainer';
// eslint-disable-next-line import/no-cycle
import MrdContactsManagementContainer
  from '../../../application/mrd-administration/contact-management/containers/MrdContactsManagementContainer';
import MrdContactsContainer
  from '../../../application/mrd-administration/contact-management/containers/MrdContactsContainer';
import IpcContactsContainer
  from '../../../application/mrd-administration/contact-management/containers/IpcContactsContainer';
import XmlContactsContainer
  from '../../../application/mrd-administration/contact-management/containers/XmlContactsContainer';
import NotificationServiceThresholdContainer
  from '../../../application/mrd-administration/notification-service/containers/NotificationServiceThresholdContainer';
import MrdAppTranslationsContainer
  from '../../../application/mrd-administration/translations/containers/MrdAppTranslationsContainer';
import DataSharingContainer from '../../../application/mrd-administration/data-sharing/containers/DataSharingContainer';

function ListTableContainer(props) {
  const {
    tableId,
    tableLoad,
  } = props;
  switch (tableId) {
  case TableDefinitions.MRD_MONITORING_REPORT_ALL_MRDS.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.MRD_MONITORING_REPORT_ALL_ISSUES.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.MRD_MONITORING_REPORT_REPORTED_BY_USER.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.MRD_MONITORING_REPORT_XML_DELAYED.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.MRD_MONITORING_REPORT_NO_SYNC.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.MRD_DENEST_IMPC_MAPPING.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.MRD.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.MRD_ADMINISTRATION_IATA.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.MRD_DEVICE_LIST_BY_COUNTRY.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.MRD_IMPC_LIST_BY_COUNTRY.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.IPC_CONTACTS.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.XML_CONTACTS.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.MRD_SETTINGS.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.NOTIFICATION_SERVICE_THRESHOLD.id:
    tableLoad(tableId);
    break;
  case TableDefinitions.DATA_SHARING_VIEW.id:
    tableLoad(tableId);
    break;
  default:
  }

  switch (tableId) {
  case TableDefinitions.MRD_MONITORING_REPORT_ALL_MRDS.id:
    return <MrdMonitoringReportsAllMRDsContainer {...props} />;
  case TableDefinitions.MRD_MONITORING_REPORT_ALL_ISSUES.id:
    return <MrdMonitoringReportsAllIssuesContainer {...props} />;
  case TableDefinitions.MRD_MONITORING_REPORT_REPORTED_BY_USER.id:
    return <MrdMonitoringReportsReportedByUserContainer {...props} />;
  case TableDefinitions.MRD_MONITORING_REPORT_XML_DELAYED.id:
    return <MrdMonitoringReportsXmlDelayedContainer {...props} />;
  case TableDefinitions.MRD_MONITORING_REPORT_NO_SYNC.id:
    return <MrdMonitoringReportsNoSyncContainer {...props} />;
  case TableDefinitions.MRD_DENEST_IMPC_MAPPING.id:
    return <DenestImpcMappingContainer {...props} />;
  case TableDefinitions.MRD.id:
    return <DeviceInformationContainer {...props} />;
  case TableDefinitions.HANDLERS_BY_MRD_DEVICE.id:
    return <HandlersContainer {...props} />;
  case TableDefinitions.MRD_CONTACTS_PAGE.id:
    return <MrdContactsManagementContainer {...props} />;
  case TableDefinitions.IPC_CONTACTS.id:
    return <IpcContactsContainer {...props} />;
  case TableDefinitions.MRD_CONTACTS.id:
    return <MrdContactsContainer {...props} />;
  case TableDefinitions.XML_CONTACTS.id:
    return <XmlContactsContainer {...props} />;
  case TableDefinitions.MRD_APP_TRANSLATIONS.id:
    return <MrdAppTranslationsContainer {...props} />;
  case TableDefinitions.MRD_ADMINISTRATION_FLIGHTS.id:
    return <FlightInformationContainer {...props} />;
  case TableDefinitions.NOTIFICATION_SERVICE_THRESHOLD.id:
    return <NotificationServiceThresholdContainer {...props} />;
  case TableDefinitions.HANDLERS_BY_IMPC.id:
    return null;
  case TableDefinitions.MRD_SETTINGS.id:
    return <DeviceSettingsContainer {...props} />;
  case TableDefinitions.DATA_SHARING_VIEW.id:
    return <DataSharingContainer {...props} />;
  default:
    return <div>Page not found</div>;
  }
}

ListTableContainer.propTypes = {
  tableId: PropTypes.string,
  tableLoad: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoad: tableLoadData,
}, dispatch);

export default connect(null, mapDispatchToProps)(ListTableContainer);
